import { render, staticRenderFns } from "./picZoom.vue?vue&type=template&id=7f06b1ae&scoped=true&"
import script from "./picZoom.vue?vue&type=script&lang=js&"
export * from "./picZoom.vue?vue&type=script&lang=js&"
import style0 from "./picZoom.vue?vue&type=style&index=0&id=7f06b1ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f06b1ae",
  null
  
)

export default component.exports